import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_PROCON } from 'services/_path';

// TYPES
import { Types } from './types';

// ACTIONS
import { tiposContratacaoSuccess, tiposContratacaoFailure } from './actions';

function* tiposContratacaoRequest() {
	const response: ApiResponse = yield call(
		postApi,
		PATH_PROCON,
		`dominios-crm/${CHANNEL}/tipos-contratacao`,
		{},
	);

	if (response.status === 200) {
		yield put(tiposContratacaoSuccess(response));
	} else {
		yield put(tiposContratacaoFailure(response));
	}
}

export default all([
	takeLatest(Types.TIPOS_CONTRATACAO_REQUEST, tiposContratacaoRequest),
]);
